module.exports = __webpack_public_path__ + "img/edit-icons.4f46d3b1.svg";